import { IHomeViewModel } from 'Types/Litium';
import BlockRenderer from 'Blocks/BlockRenderer';
import Flowbox from 'Components/Flowbox';

const HomePage = ({
    blockAreas,
    backgroundColorCode,
    pageBackgroundImage,
    flowboxViewModel,
}: IHomeViewModel) => (
    <div
        style={{
            backgroundImage:
                pageBackgroundImage.src &&
                `url(${pageBackgroundImage.src}?format=webp)`,
            backgroundColor: backgroundColorCode,
        }}
        className="grid h-full w-full"
    >
        <BlockRenderer blocks={blockAreas.main} />

        {flowboxViewModel && (
            <Flowbox
                text={flowboxViewModel.text}
                clauseText={flowboxViewModel.clauseText}
                textContainerMaxWidth={flowboxViewModel.textContainerMaxWidth}
                flowDiv={flowboxViewModel.flowDiv}
            />
        )}
    </div>
);

export default HomePage;
